import React from 'react';
import { InfoTableData } from '../../typings';
import InfoTable from '../InfoTable';
import { useTranslation } from '../../i18n';

interface BenefitsAndChallengesProps {
    isWeb: boolean;
    score: number;
    moduleType: string;
    maxCount: number;
    goodLeftCount: number;
    goodRightCount: number;
    greatLeftCount: number;
    greatRightCount: number;
    excellentLeftCount: number;
    excellentRightCount: number;
}

const BenefitsAndChallenges = (props: BenefitsAndChallengesProps) => {
    const { t } = useTranslation();
    const {
        isWeb,
        score,
        moduleType,
        excellentRightCount,
        goodRightCount,
        goodLeftCount,
        greatLeftCount,
        greatRightCount,
        excellentLeftCount,
        maxCount,
    } = props;
    const tableData: InfoTableData = {
        type: 'BENEFITS_CHALLENGES',
        leftColumn: {
            title: t(`${moduleType}.BENEFITS_CHALLENGES_TABLE.BENEFITS_TITLE`),
            data: [],
        },
        rightColumn: {
            title: t(
                `${moduleType}.BENEFITS_CHALLENGES_TABLE.CHALLENGES_TITLE`,
            ),
            data: [],
        },
    };
    for (let dataCount = 1; dataCount <= maxCount; dataCount++) {
        if (
            !!score &&
            score >= 0 &&
            score < 40 &&
            dataCount <= Math.max(goodLeftCount, goodRightCount)
        ) {
            if (dataCount <= goodLeftCount) {
                tableData.leftColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GOOD.BENEFITS_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GOOD.BENEFITS_DESC_${dataCount}`,
                    ),
                });
            }
            if (dataCount <= goodRightCount) {
                tableData.rightColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GOOD.CHALLENGES_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GOOD.CHALLENGES_DESC_${dataCount}`,
                    ),
                });
            }
        }
        if (
            !!score &&
            score >= 40 &&
            score < 60 &&
            dataCount <= Math.max(greatRightCount, greatLeftCount)
        ) {
            if (dataCount <= greatLeftCount) {
                tableData.leftColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GREAT.BENEFITS_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GREAT.BENEFITS_DESC_${dataCount}`,
                    ),
                });
            }
            if (dataCount <= greatRightCount) {
                tableData.rightColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GREAT.CHALLENGES_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.GREAT.CHALLENGES_DESC_${dataCount}`,
                    ),
                });
            }
        }
        if (
            !!score &&
            score >= 60 &&
            score <= 100 &&
            dataCount <= Math.max(excellentLeftCount, excellentRightCount)
        ) {
            if (dataCount <= excellentLeftCount) {
                tableData.leftColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.EXCELLENT.BENEFITS_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.EXCELLENT.BENEFITS_DESC_${dataCount}`,
                    ),
                });
            }
            if (dataCount <= excellentRightCount) {
                tableData.rightColumn.data.push({
                    title: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.EXCELLENT.CHALLENGES_TITLE_${dataCount}`,
                    ),
                    description: t(
                        `${moduleType}.BENEFITS_CHALLENGES_TABLE.EXCELLENT.CHALLENGES_DESC_${dataCount}`,
                    ),
                });
            }
        }
    }
    return (
        <InfoTable
            cardTitle={t(`${moduleType}.BENEFITS_CHALLENGES_TABLE.TABLE_TITLE`)}
            isWeb={isWeb}
            tableData={tableData}
        />
    );
};
export default BenefitsAndChallenges;
